import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=7a56843b&scoped=true&"
import script from "./videoUpload.vue?vue&type=script&lang=js&"
export * from "./videoUpload.vue?vue&type=script&lang=js&"
import style0 from "./videoUpload.vue?vue&type=style&index=0&id=7a56843b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56843b",
  null
  
)

export default component.exports